import styled from '@emotion/styled'

import { DefaultElementProps } from 'common/interfaces'

import { RichText as RichTextProps } from './interface'

export default function RichText({
  html,
  style,
}: RichTextProps & DefaultElementProps): JSX.Element {
  const StyledDiv = styled.div(style ?? '')

  return <StyledDiv dangerouslySetInnerHTML={{ __html: html }} />
}
